<div class="wrapper">
  <section id="area-breadcrumb" style="padding-top: 25px;">
    <div class="container">
      <nav class="breadcrumb">
        <ul>
          <li><a href="/"><strong>Home</strong></a></li>
          <span><i class="fas fa-chevron-right"></i></span>
          <li><a routerLink="/hoteis"><strong>Destinos</strong></a></li>
          <span><i class="fas fa-chevron-right"></i></span>
          <li>{{detalheDestino?.titulo}}, {{detalheDestino?.estado}}</li>
        </ul>
      </nav>
    </div>
  </section>
  <section id="detalhes-hotel">
    <div class="container is-fluid">
      <div class="columns">
        <div class="column is-3" id="montreal-hotel-busca">
          <div class="bg-hoteis">
            <p-autoComplete class="filtro-busca" [(ngModel)]="brand" field="data.nome" [suggestions]="filteredBrands"
              (completeMethod)="filterBrands($event)" (onSelect)="selectInAutoComplete()" [size]="30" [minLength]="1"
              placeholder="Refazer a busca">
              <ng-template let-brand pTemplate="item" class="w-100 h-auto-complete">
                <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                  <div style="width:auto;display:inline-block;margin:5px 0 2px 5px">
                    <p>{{getNomeAutoComplete(brand)}} <br>
                      <small>{{getDetalheAutoComplete(brand)}}</small></p>
                  </div>
                  <div style="font-size:13px;float:right;margin: 17px 10px 0 0">
                    {{getQuantidadeHoteis(brand)}} </div>
                </div>
              </ng-template>
            </p-autoComplete>
            <div class="icon-map"><i class="far fa-map-marker"></i></div>
            <div class="hoteis-proximos">
              <h3>Hotéis</h3>
              <p><strong>{{detalheDestino?.titulo}}, {{detalheDestino?.estado}}</strong></p>
              <div class="opcoes-proximas" *ngFor="let item of resultHoteis?.hoteis">
                <figure class="area-thumb">
                  <img class="thumb" [src]="item.fotos[0]" />
                </figure>
                <div class="area-text">
                  <h5>{{item.nome}}</h5>
                  <a (click)="irParaHotel(item)" class="ver-detalhes">Ver detalhes</a>
                </div>
              </div>



              <a class="todos-hoteis" routerLink="/busca-hoteis" [queryParams]="{ codCidade: detalheDestino?.id }">Todos
                os Hotéis desta cidade</a>

            </div>
          </div>
        </div>
        <div class="column is-9 resultado-hoteis">
          <div class="columns">
            <div class="column is-8 no-padding-bottom">
              <span class="estado"><i class="fas fa-map-marker"></i>{{detalheDestino?.estado}}</span>
              <h1 class="cidade">{{detalheDestino?.titulo}}</h1>
            </div>
            <div class="column is-4 ordenar-busca">
              <div class="menu-right">
                <ul class="nav-page">
                  <li><a (click)="scroll('target_sobre_destino')">Sobre {{detalheDestino?.titulo}},
                      {{detalheDestino?.estado}}</a></li>
                  <li><a (click)="scroll('target_informacao_destino')">Informações</a></li>
                </ul>
              </div>
            </div>
          </div>
          <p class="descricao-destino" [innerHTML]="detalheDestino?.resumo"></p>
          <div id="galeria-hotel">
            <p-galleria [images]="images" panelHeight="455" [autoPlay]="true" [showCaption]="true" panelWidth="100%">
            </p-galleria>
          </div>

          <h3 id='target_sobre_destino'>Sobre {{detalheDestino?.titulo}}</h3>

          <p [innerHTML]="detalheDestino?.descricao"></p>

          <h3 id='target_informacao_destino'>Informações Importantes</h3>

          <p><strong>Recomendado para</strong></p>

          <p class="recomendado-para" *ngIf="detalheDestino && checkExisteRecomendacao('Praia')"><i
              class="fas fa-sun"></i>Praia</p>
          <p class="recomendado-para" *ngIf="detalheDestino && checkExisteRecomendacao('Luxo')"><i
              class="fas fa-gem"></i>Luxo</p>
          <p class="recomendado-para" *ngIf="detalheDestino && checkExisteRecomendacao('Relaxar')"><i
              class="fas fa-spa"></i>Relaxar</p>

          <p class="recomendado-para" *ngIf="detalheDestino && checkExisteRecomendacao('Natureza')"><i
              class="fas fa-mountain"></i>Natureza</p>

          <p><strong>Clima</strong></p>

          <p class="descricao-clima">{{detalheDestino?.climaDescricao}}</p>



          <p><strong>Transporte</strong></p>

          <p class="descricao-transporte">{{detalheDestino?.transporte}}</p>


          <p><strong>Demanda</strong></p>

          <img class="img-demanda" [src]="detalheDestino?.imgDemanda" />
          <span [innerHTML]="detalheDestino?.demandaDescricao"></span>
        </div>
      </div>
    </div>
  </section>
  <app-tabela-diarias></app-tabela-diarias>
  <app-footer></app-footer>
</div>
